const API_RESILIENCE_CONFIG = {
  "storage-module": {
    optional: true, // Module is optional, we can continue without it
    fallbackValue: null, // Default value in case of error
    logLevel: "warn", // Log level (warn instead of error)
  },
  // Add other modules here as needed
  // "user-profile": { optional: false, ... }
};

const logResilienceError = (moduleName, error, logLevel = "warn") => {
  const message = `[API Resilience] Module "${moduleName}" unavailable (status: ${error.response?.status}), continuing with fallback value.`;
  const details = {
    status: error.response?.status,
    message: error.message,
    endpoint: error.config?.url,
  };

  const logger = console[logLevel] || console.warn;
  logger(message, details);
};

export const fetchWithResilience = async (apiCall, moduleName) => {
  const config = API_RESILIENCE_CONFIG[moduleName];

  // If no config, default behavior: let the error appears
  if (!config) {
    return apiCall();
  }

  try {
    return await apiCall();
  } catch (error) {
    // If module is optional, handle error gracefully
    if (config.optional) {
      logResilienceError(moduleName, error, config.logLevel);
      return config.fallbackValue;
    }

    throw error;
  }
};

export default fetchWithResilience;
